
import React, { useState, useEffect } from 'react';
import { Modal, Button, Form } from "react-bootstrap";
import axios from 'axios';
import { toast } from "react-hot-toast";

const TagModal = ({ show, onHide, tag, onSuccess }) => {
    const isEdit = !!tag;
    const [tagName, setTagName] = useState("");
    const [tagColor, setTagColor] = useState("#000000");
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (tag) {
            setTagName(tag.name);
            setTagColor(tag.color);
        } else {
            setTagName("");
            setTagColor("#000000");
        }
    }, [tag, show]);

    const handleSave = async () => {
        if (!tagName || !tagColor) {
            toast.error("Please fill all fields");
            return;
        }
        setLoading(true);
        try {
            const payload = { name: tagName, color: tagColor };
            let res;
            if (isEdit) {
                res = await axios.put(`${process.env.REACT_APP_API_URL}/admin/tags/${tag.id}`, payload, {
                    headers: { 'access-token': localStorage.getItem('accessToken') }
                });
            } else {
                res = await axios.post(`${process.env.REACT_APP_API_URL}/admin/tags`, payload, {
                    headers: { 'access-token': localStorage.getItem('accessToken') }
                });
            }

            if (res.data.status) {
                toast.success(isEdit ? "Tag updated successfully" : "Tag created successfully");
                onSuccess();
                onHide();
            } else {
                toast.error(res.data.error || res.data.message || "Operation failed");
            }

        } catch (error) {
            console.error(error);
            toast.error(error.response?.data?.message || "Operation failed");
        } finally {
            setLoading(false);
        }
    }

    return (
        <Modal show={show} onHide={onHide} centered>
            <Modal.Header closeButton>
                <Modal.Title>{isEdit ? "Edit Tag" : "Add Tag"}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Form.Group className="mb-3">
                        <Form.Label>Name</Form.Label>
                        <Form.Control
                            type="text"
                            value={tagName}
                            onChange={(e) => setTagName(e.target.value)}
                            placeholder="e.g. Premium"
                        />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>Color</Form.Label>
                        <Form.Control
                            type="color"
                            value={tagColor}
                            onChange={(e) => setTagColor(e.target.value)}
                            style={{ height: '50px' }}
                        />
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>Close</Button>
                <Button className="admin-btn" onClick={handleSave} disabled={loading}>
                    {loading ? "Saving..." : "Save"}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default TagModal;
